let arrLeonardGTMTrackingFormPath = [];
let menuWidth = 1024;
// let menuWidth = parseInt(
//   jQuery(":root").css("--breakpoint-menubp").replace("px", "")
// );

jQuery(document).ready(function () {
  charlRedirectContactForm();
  initLeonardGTMTracking();

  jQuery(document).on(
    "click",
    ".main-nav-menu .menu > li.menu-item-has-children > a",
    charlHeaderOpenSubMenu
  );
  jQuery(document).on("click", ".mobile-menu-btn", charlToggleOverlayMenu);

  jQuery(document).on(
    "touchstart",
    ".main-nav-menu .menu > li.menu-item-has-children > a",
    charlTouchStart
  );


  charlAdjustEmailObfuscation();

  charlHandleScroll();
  jQuery(window).scroll(function () {
    debounce(charlHandleScroll, 25);
  });

  charlSetDynamicHeaderHeight();
  jQuery(window).resize(function () {
    charlSetDynamicHeaderHeight();
  });

  if (jQuery(window).width() >= menuWidth) {
    jQuery(document).on(
      "mouseenter",
      ".main-nav-menu > div > .menu > li.menu-item-has-children",
      charlDetectSubMenuOverflow
    );
  }

  jQuery(".accordion-box .toggle-link").on("click", charlToggleAccordionBox);

  charlHandleNewsletterSubmit();

  charlInitCookiesButtons();

});

/**
 * Replace the href of all .cookies-button elements with javascript:openAxeptioCookies()
 * to trigger the Axeptio cookie consent dialog on click.
 */
function charlInitCookiesButtons() {
  jQuery(".cookies-button a").attr("href", "javascript:openAxeptioCookies()");
}

export function charlSetDynamicHeaderHeight() {
  jQuery(":root").css(
    "--header-height",
    jQuery(".main-header-fixed").innerHeight() + "px"
  );

  if (jQuery("#wpadminbar").length) {
    jQuery(":root").css(
      "--admin-bar-height",
      jQuery("#wpadminbar").innerHeight() + "px"
    );
  }
}

/**
 * Handle newsletter subscription form submission via AJAX
 */
function charlHandleNewsletterSubmit() {
  jQuery('#mc-embedded-subscribe-form').on('submit', function(e) {
    e.preventDefault();
    
    const $form = jQuery(this);
    const $response = $form.find('.newsletter-response');
    const $submitBtn = $form.find('#mc-embedded-subscribe');
    const $emailInput = $form.find('#mce-EMAIL');
    
    // Disable submit button
    $submitBtn.prop('disabled', true);
    
    // Get form data
    const formData = $form.serialize();
    let actionUrl = $form.attr('action');
    
    // Convert POST URL to JSONP
    actionUrl = actionUrl.replace('/post?', '/post-json?');
    
    jQuery.ajax({
      url: actionUrl,
      data: formData,
      dataType: 'jsonp',
      jsonp: 'c',
      contentType: 'application/json; charset=utf-8',
      error: function(error) {
        $response.removeClass('hidden text-green-600').addClass('text-red-600');
        $response.html('Une erreur est survenue. Veuillez réessayer.');
        $submitBtn.prop('disabled', false);
      },
      success: function(data) {
        if (data.result === 'success') {
          $response.removeClass('hidden text-red-600').addClass('text-green-600');
          $response.html('Merci pour votre inscription!');
          $emailInput.val('');
        } else {
          $response.removeClass('hidden text-green-600').addClass('text-red-600');
          let message = data.msg || 'Une erreur est survenue. Veuillez réessayer.';
          // Remove HTML tags from Mailchimp error message
          message = message.replace(/<[^>]*>/g, '');
          $response.html(message);
        }
        $submitBtn.prop('disabled', false);
      }
    });
  });
}

// Handle scroll events (ie: fexed menu background)
function charlHandleScroll() {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > 0) {
    jQuery(".main-header-fixed").addClass("scrolled");
  }
  if (scrollTop == 0) {
    jQuery(".main-header-fixed").removeClass("scrolled");
  }
}

function charlRedirectContactForm() {
  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      let redirectUrl = jQuery("input[name=redirect_url]").val();
      if (redirectUrl != undefined) {
        location = redirectUrl;
      }
    },
    false
  );
}

function initLeonardGTMTracking() {
  // Track CTA pointing to a «Leads Form»
  // -------
  let arrLeonardGTMTrackingCTA = [];

  for (let i = 0; i < arrLeonardGTMTrackingFormPath.length; i++) {
    arrLeonardGTMTrackingCTA.push(
      "a.p-btn[href*='" +
        arrLeonardGTMTrackingFormPath[i] +
        "'], a.p-button[href*='" +
        arrLeonardGTMTrackingFormPath[i] +
        "']"
    );
  }

  // Custom CSS rules here
  // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

  jQuery(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

  // Track «Leads form» submit button click
  // -------
  if (arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
    jQuery("form button, form input[type=submit]").addClass(
      "gtm-form-submited"
    );
  }
}

export function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId = setTimeout(function () {
    method();
  }, delay);
}

export function charlSetCookie(name, value, hours) {
  var date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  var expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

export function charlGetCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function charlToggleAccordionBox(e) {
    e.preventDefault();
    const $accordionBox = jQuery(this).parents(".accordion-box");
    const $content = $accordionBox.find(".content");
    const $toggleElement = $accordionBox.find(".toggle-element");
    
    // Animer le contenu en premier
    $content.slideToggle(300, function() {
        // Après l'animation, synchroniser les classes avec l'état final
        if ($content.is(':visible')) {
            $accordionBox.addClass("opened");
            $toggleElement.addClass("opened");
        } else {
            $accordionBox.removeClass("opened");
            $toggleElement.removeClass("opened");
        }
    });
    
    // Toggle immédiat pour l'icône seulement (si nécessaire)
    $toggleElement.toggleClass("opened");
}

/**
 * Open the mobile sub menu items on the parent link click
 */
function charlHeaderOpenSubMenu(e) {
  if (jQuery(window).width() < menuWidth) {
    jQuery(this).toggleClass("opened");
    jQuery(this).parent().find(".sub-menu").first().toggleClass("opened");

    e.preventDefault();
  }
}

function charlToggleOverlayMenu(e) {
  if (jQuery(window).width() < menuWidth) {
    jQuery(this).toggleClass("menu-open");
    jQuery("html").toggleClass("menu-open");
    jQuery("header .main-nav-menu").toggleClass("hidden");

    e.preventDefault();
  }
}


export function charlAdjustEmailObfuscation() {
  jQuery(".mailto-obfuscate").each(function () {
    let encrypted_email = jQuery(this).data("value");
    if (encrypted_email) {
      jQuery(this).attr("href", "mailto:" + atob(encrypted_email));
      if (jQuery(this).hasClass("replace-text")) {
        jQuery(this).text(atob(encrypted_email));
      }
    }
  });
}

/**
 * If a sub menu is overflowing the viewport height on desktop, add a class to add an overflow and max height
 */
function charlDetectSubMenuOverflow() {
  jQuery(".main-nav-menu > div > .menu > li > .sub-menu").each(function () {
    var $submenu = jQuery(this);
    $submenu.removeClass("submenu-overflow"); // Reset class
    // Only check if submenu is visible
    if ($submenu.is(":visible")) {
      var rect = $submenu[0].getBoundingClientRect();
      if (rect.bottom > window.innerHeight) {
        $submenu.addClass("submenu-overflow");
      }
    }
  });
}

function charlTouchStart(e) {
  if (window.innerWidth > menuWidth) {
    jQuery(".main-nav-menu").addClass("prevent-tablet");
  }
}
